export default class EventEmitter {
    constructor() {
        this.events = {};
    }
    on(event, callback) {
        if (typeof this.events[event] !== 'object') {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }
    off(event, callback) {
        this.removeListener(event, callback);
    }
    removeListener(event, callback) {
        if (typeof this.events[event] === 'object') {
            const index = this.events[event].indexOf(callback);
            if (index !== -1) {
                this.events[event].splice(index, 1);
            }
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(event, value) {
        if (typeof this.events[event] === 'object') {
            // biome-ignore lint/suspicious/noExplicitAny: -
            // biome-ignore lint/suspicious/useIterableCallbackReturn: -
            this.events[event].filter((cb) => cb != null).forEach((cb) => cb(value));
        }
    }
}
//# sourceMappingURL=eventEmitter.js.map